import { useAuth0 } from '@auth0/auth0-react';
import posthog from 'posthog-js';
import { clearStepUp } from 'shared/utils/redirect-to-step-up';

export const useLogout = ({ returnTo = '/login' }: { returnTo?: string } = {}) => {
  const { logout } = useAuth0();

  return () => {
    posthog.reset();
    clearStepUp();
    logout({ logoutParams: { returnTo: `${window.location.origin}${returnTo}` } });
  };
};
